"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTokenProvider = exports.hasTokenProvider = exports.getGlobal = exports.isValid = exports.createFromJWT = exports.now = void 0;
var jwt_decode_1 = __importDefault(require("jwt-decode"));
var AccessToken_1 = require("./AccessToken");
var MigrosTokenProvider_1 = require("./MigrosTokenProvider");
var TokenError_1 = require("./TokenError");
var globalContext = {};
/**
 * returns current timestamp in number of seconds since unix epoch
 */
function now() {
    return Math.floor(Date.now() / 1000);
}
exports.now = now;
/**
 * create an access token from a jwt.
 * @param token jwt
 * @param payload additional payload
 */
function createFromJWT(token, payload) {
    try {
        var parsed = (0, jwt_decode_1.default)(token);
        var _a = parsed, scope = _a.scope, exp = _a.exp;
        return new AccessToken_1.AccessToken(token, exp, scope, payload);
    }
    catch (err) {
        throw TokenError_1.TokenError.Invalid;
    }
}
exports.createFromJWT = createFromJWT;
/**
 * check if a given token is valid
 * @param token access token.
 * @param nowFn optional function that returns current timestamp.
 */
function isValid(token, nowFn) {
    if (nowFn === void 0) { nowFn = now; }
    return token !== null && nowFn() < token.expiresAt;
}
exports.isValid = isValid;
/**
 * Gets global (aka window) or an empty object if undefined.
 */
function getGlobal() {
    if (typeof window !== 'undefined') {
        return window;
    }
    return globalContext;
}
exports.getGlobal = getGlobal;
/**
 * Checks if MigrosTokenProvider is in window.
 */
function hasTokenProvider() {
    return !!getGlobal().MigrosTokenProvider;
}
exports.hasTokenProvider = hasTokenProvider;
/**
 * Returns window.MigrosTokenProvider.
 * If not yet existing: creates a new TokenProvider and assigns it to window.
 */
function getTokenProvider(defaultProvider, reset) {
    if (defaultProvider === void 0) { defaultProvider = new MigrosTokenProvider_1.MigrosTokenProvider(); }
    var global = getGlobal();
    if (!hasTokenProvider() || reset) {
        global.MigrosTokenProvider = defaultProvider;
    }
    return global.MigrosTokenProvider;
}
exports.getTokenProvider = getTokenProvider;
